import { createI18n, resolveLocale } from '@instanexus/i18n';

/**
 * Builds the app's i18next instance and binds it to react-i18next.
 *
 * `createI18n({ bindReact: true })` (the default) registers the instance as
 * react-i18next's active one, which is what makes `useTranslation()` work
 * everywhere below the root — the factory IS the provider setup.
 *
 * Locale resolution is the docs/011 order. In the browser only step 3 is
 * available until S1 puts a user preference and a tenant default on the token.
 */
export function initI18n(): ReturnType<typeof createI18n> {
  return createI18n({
    locale: resolveLocale({ acceptLanguage: navigator.language }),
  });
}
